/* eslint-disable */
<template>
  <!-- eslint-disable -->
  <b-container class="mt-4">
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(updateCategoryDefinition)" novalidate>
        <h2 class="mb-4">
          <span v-if="categoryDefinition._id">Edit</span>
          <span v-else>Add new</span>
          {{ title }} definition
        </h2>

        <b-alert :show="showAlert">{{ alert }}</b-alert>

        <b-form-group label-cols="2" label="Name" label-for="category-definition-display-name">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 pr-3">
              <b-form-input
                id="category-definition-display-name"
                v-model="display_name"
                required
              ></b-form-input>

              <b-form-invalid-feedback>
                Name is required
              </b-form-invalid-feedback>
            </div>

            <div class="flex">
              <b-form-checkbox size="lg" v-model="has_attributes" name="check-button" switch>
                Attributes
              </b-form-checkbox>
            </div>
          </div>
        </b-form-group>

        <b-form-group
          label-cols="2"
          label="Description"
          label-for="category-definition-description"
        >
          <b-form-textarea
            id="category-definition-description"
            v-model="categoryDefinition.description"
            rows="3"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group label-cols="2" label="Type" label-for="category-definition-type">
          <b-form-select
            id="category-definition-type"
            :options="type_options"
            v-model="type_val"
            required
          >
            <template v-slot:first>
              <option :value="null" disabled>Choose...</option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group
          label-cols="2"
          label="Data"
          label-for="category-definition-data"
          v-if="categoryDefinition.type && categoryDefinition.type.needs_data"
        >
          <b-form-input
            id="category-definition-data"
            v-model="categoryDefinition.data"
            :placeholder="categoryDefinition.type.description"
          >
          </b-form-input>
          <b-form-invalid-feedback>
            Data is required for {{ categoryDefinition.type.display_name }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-card title="Attributes" class="mt-5" v-if="has_attributes">
          <ValidationObserver v-slot="invalid">
            <b-form class="container" @submit="addNewAttributeDefinition" novalidate>
              <b-row>
                <b-col cols class="pl-0">
                  <b-form-group
                    class="mb-0"
                    label="Name (key)"
                    label-for="newattribute-definition-name"
                  >
                    <b-form-input
                      id="newattribute-definition-name"
                      v-model="newAttributeDefinition.display_name"
                      required
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Name is required
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col cols>
                  <b-form-group class="mb-0" label="Type" label-for="newattribute-definition_type">
                    <b-form-select
                      id="newattribute-definition_type"
                      v-model="newAttributeDefinition.categoryDefinition"
                      required
                    >
                      <optgroup label="categories">
                        <option
                          v-for="categoryDefinition in allCategoryDefinitions"
                          :key="categoryDefinition._id"
                          :value="categoryDefinition"
                        >
                          {{ categoryDefinition.display_name }}
                        </option>
                      </optgroup>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <b-col cols>
                  <b-form-group class="mb-0" label="Data">
                    <div
                      v-if="
                        newAttributeDefinition.categoryDefinition &&
                          newAttributeDefinition.categoryDefinition.data
                      "
                    >
                      {{ newAttributeDefinition.categoryDefinition.data }}
                    </div>

                    <div v-else class="text-muted form-control-line-height">
                      No Value
                    </div>
                  </b-form-group>
                </b-col>

                <b-col cols="2" class="btn-icon-bottom">
                  <b-button
                    class="btn-icon d-flex justify-content-center align-items-center"
                    size="sm"
                    variant="primary"
                    type="submit"
                  >
                    <icon name="plus"></icon>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </ValidationObserver>

          <div
            class="attribute-definition"
            v-for="(attributeDefinition) in categoryDefinition.attributes"
            :key="attributeDefinition.key"
          >
            <b-form class="container" novalidate v-if="attributeDefinition === updating_attribute">
              <b-row>
                <b-col sm="3" class="pl-0">
                  <b-form-input
                    id="updating-attribute-name"
                    v-model="attributeDefinition.display_name"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Name is required
                  </b-form-invalid-feedback>
                </b-col>
                <b-col sm="3">
                  <ValidationProvider rules="required" v-slot="v">
                    <b-form-select
                      id="updating-attribute-type"
                      v-model="attributeDefinition.categoryDefinition"
                      :validated="!v.pristine"
                    >
                      <optgroup label="attributes">
                        <option
                          v-for="categoryDefinition in allCategoryDefinitions"
                          :key="categoryDefinition._id"
                          :value="categoryDefinition"
                        >
                          {{ categoryDefinition.display_name }}
                        </option>
                      </optgroup>
                    </b-form-select>

                    <b-form-invalid-feedback v-each="err in v.errors">
                      {{ err }}
                    </b-form-invalid-feedback>
                  </ValidationProvider>
                </b-col>
                <b-col sm="4" v-if="categoryDefinition.data">
                  {{ categoryDefinition.data }}
                </b-col>
                <b-col v-else sm="4" class="text-muted form-control-line-height">
                  No value
                </b-col>
                <b-col>
                  <b-button
                    class="btn-icon d-flex justify-content-center align-items-center"
                    size="sm"
                    variant="success"
                    @click="saveUpdatingAttribute()"
                    ><icon name="check"></icon
                  ></b-button>
                </b-col>
              </b-row>
            </b-form>

            <b-container class="attribute-definition__item" v-else sm="12">
              <b-row>
                <b-col class="pl-0 d-flex align-items-center">
                  {{ attributeDefinition.display_name }} ({{ attributeDefinition.key }})
                </b-col>
                <b-col>
                  <span v-if="attributeDefinition.categoryDefinition">
                    {{ attributeDefinition.categoryDefinition.display_name }}
                  </span>
                </b-col>
                <b-col>
                  <span v-if="attributeDefinition.categoryDefinition">
                    {{ attributeDefinition.categoryDefinition.data }}
                  </span>
                </b-col>
                <b-col cols="2">
                  <b-button
                    class="btn-icon d-flex justify-content-center align-items-center"
                    size="sm"
                    variant="primary"
                    :disabled="updating_attribute"
                    @click="setUpdatingAttribute(attributeDefinition)"
                    ><icon name="pen"></icon
                  ></b-button>
                  <b-button
                    class="btn-icon d-flex justify-content-center align-items-center"
                    size="sm"
                    variant="danger"
                    @click="removeAttribute(attributeDefinition.key)"
                    ><icon name="times"></icon
                  ></b-button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-card>

        <b-button type="submit" variant="primary" size="large" class="mt-4">Save</b-button>
      </b-form>
    </ValidationObserver>
  </b-container>
</template>
<script>
/* eslint-disable */
import { API } from '../../api';
import { debounce, each, map, find, get } from 'lodash';

const api = new API();

export default {
  name: 'CategoryDefinitionForm',
  props: ['collection', 'title'],
  data: function() {
    return {
      has_attributes: false,
      categoryDefinition: {
        display_name: null,
        key: null,
        _id: null,
        description: null,
        class: 'simple',
        type: {
          value: null,
          text: null,
          disabled: false,
        },
        data: null,
        attributes: [],
      },
      newAttributeDefinition: {
        display_name: null,
        key: null,
        categoryDefinition: null,
      },
      display_name: null, // Needed for watcher
      updating_attribute: null,
      allCategoryDefinitions: [],
      allTypes: [],
      search: '',
      alert: '',
      showAlert: false,
      showAttributeForm: false,
      updating_attributes: [],
    };
  },
  methods: {
    mapCategoryDefinitionsForAttributes() {
      if (this.categoryDefinition.attributes) {
        let me = this;
        for (let i = 0; i < this.categoryDefinition.attributes.length; ++i) {
          each(this.allCategoryDefinitions, function(categoryDefinition) {
            if (categoryDefinition._id == me.categoryDefinition.attributes[i]._id) {
              me.categoryDefinition.attributes[i].categoryDefinition = categoryDefinition;
            }
          });
          if (!this.categoryDefinition.attributes[i].categoryDefinition) {
            this.alert =
              'Cannot find category definition for ' + this.categoryDefinition.attributes[i]._id;
            this.showAlert = true;
          }
        }
      }
    },
    resetCategoryDefinition() {
      this.categoryDefinition = {
        display_name: null,
        key: null,
        _id: null,
        description: null,
        class: 'simple',
        type: null,
        data: null,
        attributes: [],
      };
    },
    resetNewAttributeDefinition() {
      this.newAttributeDefinition = {
        display_name: null,
        key: null,
        categoryDefinition: null,
      };
    },
    showErrorMessage(msg) {
      this.alert = msg;
      this.showAlert = true;
    },
    categoryDefinitionExists: debounce(function() {
      if (!this.categoryDefinition._id) {
        let me = this;
        let filter = {
          key: me.categoryDefinition.key,
        };
        api
          .findOne(this.collection, filter)
          .then(response => {
            me.showErrorMessage(
              'Category definition key ' + me.categoryDefinition.key + ' already exists.',
            );
          })
          .catch(error => {
            me.alert = '';
            me.showAlert = false;
          });
      }
    }, 500),
    getTypes() {
      api
        .getTypes()
        .then(response => {
          this.allTypes = response.data;
          if (this.title == 'template') {
            each(this.allTypes, function(type) {
              if (type.display_name == 'Section') {
                this.categoryDefinition.type = type;
                return;
              }
            });
          }
        })
        .catch(error => {
          console.warn(error);
        });
    },
    getCategoryDefinitions() {
      let filter = {};
      if (this.search) {
        filter['search'] = this.search;
      }
      api
        .find('terms', filter)
        .then(response => {
          this.allCategoryDefinitions = response.data;
        })
        .catch(error => {
          console.warn(error);
        });
    },
    updateCategoryDefinition(evt) {
      evt.preventDefault();

      let categoryDefinition = this.categoryDefinition;
      let category_name = this.categoryDefinition.display_name;
      if (categoryDefinition.class == 'simple') {
        categoryDefinition.attributes = [];
      }
      for (let i = 0; i < categoryDefinition.attributes.length; ++i) {
        categoryDefinition.attributes[i]._id =
          categoryDefinition.attributes[i].categoryDefinition._id;
        delete categoryDefinition.attributes[i].categoryDefinition;
      }
      if (categoryDefinition._id) {
        let id = categoryDefinition['_id'];
        delete categoryDefinition['_id'];
        api
          .replaceOne(this.collection, id, categoryDefinition)
          .then(response => {
            this.alert = 'Updated category definition for ' + category_name;
            this.showAlert = true;
            setTimeout(() => {
              this.$router.go();
            }, 500);
          })
          .catch(error => {
            console.warn(error);
            const msg = 'Unable to update category definition: ' + error;
            this.showErrorMessage(msg);
          });
      } else {
        delete categoryDefinition['_id'];
        api
          .post(this.collection, categoryDefinition)
          .then(response => {
            this.alert = 'Updated ' + category_name;
            this.showAlert = true;
            this.resetCategoryDefinition();
            this.getCategoryDefinitions();
            setTimeout(() => {
              this.$router.go();
            }, 500);
          })
          .catch(error => {
            console.warn(error);
            const msg = 'Unable to create new category definition: ' + error;
            this.showErrorMessage(msg);
          });
      }
    },
    addNewAttributeDefinition(evt) {
      evt.preventDefault();

      this.showAttributeForm = true;
      if (
        this.categoryDefinition.attributes === null ||
        typeof this.categoryDefinition.attributes === 'undefined'
      ) {
        this.categoryDefinition.attributes = [];
      }
      this.newAttributeDefinition.key = this.slugify(this.newAttributeDefinition.display_name);
      this.categoryDefinition.attributes.push(
        JSON.parse(JSON.stringify(this.newAttributeDefinition)),
      );
      this.resetNewAttributeDefinition();
    },
    removeAttribute(key) {
      let index = -1;
      each(this.categoryDefinition.attributes, function(attribute, i) {
        if (attribute.key === key) {
          index = i;
        }
      });
      if (index !== -1) {
        this.categoryDefinition.attributes.splice(index, 1);
      }
    },
    setUpdatingAttribute(attributeDefinition) {
      this.updating_attribute = attributeDefinition;
    },
    saveUpdatingAttribute() {
      this.updating_attribute = null;
    },
    slugify(val) {
      if (!val) {
        return val;
      }
      return val.toLowerCase().replace(/\s+/g, '_');
    },
  },
  created() {
    this.getCategoryDefinitions();
    this.getTypes();

    if (this.$route.params.id) {
      let filter = {
        _id: this.$route.params.id,
      };
      api
        .findOne(this.collection, filter)
        .then(response => {
          const categoryDefinition = response.data;
          this.categoryDefinition = categoryDefinition;
          this.display_name = categoryDefinition.display_name;
          this.mapCategoryDefinitionsForAttributes();

          // Special case for "section"
          if (this.categoryDefinition.data === 'Section') {
            this.categoryDefinition.type = {
              key: 'section',
              display_name: 'Section',
              description: 'Template section',
              class: 'simple',
              needs_data: false,
            };
          }

          // Check for attributes
          if (this.categoryDefinition.attributes) {
            this.has_attributes = true;
          }

          this.$forceUpdate();
        })
        .catch(error => {
          this.alert = 'Unable to retrieve this category definition: ' + error;
          this.showAlert = true;
          console.warn(error);
        });
    }
  },
  watch: {
    display_name: function(val) {
      if (!this.categoryDefinition._id) {
        this.categoryDefinition.key = this.slugify(val);
        this.categoryDefinitionExists();
      }
      this.categoryDefinition.display_name = val;
    },
    has_attributes: function(val) {
      if (val === true) {
        this.categoryDefinition.class = 'complex';
      } else {
        this.categoryDefinition.class = 'simple';
      }
    },
  },
  computed: {
    type_options() {
      const options = map(this.allTypes, (item, index) => {
        return {
          value: item.key,
          text: item.display_name,
          disabled: false,
        };
      });

      return options;
    },
    type_val: {
      get() {
        // Empty
        const type = this.categoryDefinition.type;
        if (type === null) return null;

        // Selected
        return type.key;
      },
      set(selected) {
        const value = get(selected, 'value', null);
        if (!value) return;

        const type = find(this.allTypes, item => {
          return selected.value === item.key;
        });

        this.categoryDefinition.type = type || null;
      },
    },
  },
};
</script>

<style scoped>
.btn-group {
  display: inline-block;
}
.btn-icon {
  width: 32px;
  height: 32px;
  display: inline-flex !important;
}
.btn-icon + .btn-icon {
  margin-left: 10px;
}
.field-label {
  text-align: right;
}
.form-control-line-height {
  line-height: 38px;
}
.btn-icon-bottom {
  padding-top: 34px;
}
.attribute-definition {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid #ccc;
  padding-left: 0;
  padding-right: 0;
}
.attribute-definition .row {
  margin-top: 0;
  padding-left: 0;
  padding-right: 0;
}
</style>
